import { ColumnsType } from 'antd/lib/table';
import { SortOrder } from 'antd/lib/table/interface';
import { TranslationKey, useTranslate } from 'hooks/use-translation';
import { TableFieldTypes } from '../components';
import {
  ColumnOptions,
  CompareObjectType,
  predictIfTemplateRequired,
  toColumnDef,
} from '../utils';

export interface PhaseRecord {
  phaseTemplateName: string;
  templateName: string;
  plannedDuration: number;
  average: CompareObjectType;
  p50: CompareObjectType;
  p90: CompareObjectType;
  phasesCompletedLate: number;
  csat: number;
}

export const usePhaseViewColumn = ({
  isTemplateColumnRequired,
}: ColumnOptions): ColumnsType<PhaseRecord> => {
  const translate = useTranslate();
  const getColumnTitle = (suffix: string) =>
    translate(
      `reports.template_insight.overview.phases.table.${suffix}` as TranslationKey,
    );

  return [
    {
      key: 'phaseTemplateName',
      fieldType: TableFieldTypes.String,
      defaultSortOrder: 'ascend' as SortOrder,
    },
    {
      key: 'templateName',
      fieldType: TableFieldTypes.String,
    },
    {
      key: 'plannedDuration',
      fieldType: TableFieldTypes.Days,
    },
    {
      key: 'average',
      fieldType: TableFieldTypes.CompareValue,
    },
    {
      key: 'p50',
      fieldType: TableFieldTypes.CompareValue,
    },
    {
      key: 'p90',
      fieldType: TableFieldTypes.CompareValue,
    },
    {
      key: 'phasesCompletedLate',
      fieldType: TableFieldTypes.Percentage,
    },
    {
      key: 'csat',
      fieldType: TableFieldTypes.Number,
    },
  ]
    .map((x) => toColumnDef(x, getColumnTitle))
    .filter((x) => predictIfTemplateRequired(x.key, isTemplateColumnRequired));
};
